import aidajuoksu from './img/aidajuoksu.png';

export function Aidajuoksu() {
  return (
    <div className="container">
      <img className="aidajuoksu" src={aidajuoksu} alt="" />
    </div>
  );
}
